module.exports = new __parcel__URL__("More.cf799018.svg").toString();